import { FC } from 'react'

import { Section } from 'components/section'
import { Heading } from 'components/heading'
import { Markdown } from 'components/markdown'
import { TeamPerson } from 'api/strapi/teams/types'
import { TeamMemberItem, TeamMemberItemProps } from 'components/team-members'
import { cn } from 'utils'

import classes from './team.module.css'

interface TeamSectionProps {
  people: TeamPerson[]
  title?: string
  subtitle?: string
  content?: string
  linkTarget?: TeamMemberItemProps['linkTarget']
  className?: string
  classNameHeader?: string
  classNameList?: string
}

export const Team: FC<TeamSectionProps> = ({
  people,
  content,
  title,
  subtitle,
  className,
  classNameHeader,
  classNameList,
  linkTarget,
}) => {
  if (!people?.length) return null

  return (
    <Section className={cn(classes.container, className)} theme="hero">
      <header className={cn(classes.header, classNameHeader)}>
        {subtitle && (
          <Heading theme="h6" component="h3" className={classes.subtitle}>
            {subtitle}
          </Heading>
        )}
        {title && (
          <Heading theme="h2" className={classes.title}>
            {title}
          </Heading>
        )}
        {content && <Markdown>{content}</Markdown>}
      </header>
      <ul className={cn(classes.list, classNameList)}>
        {people?.map((teamMember) => (
          <TeamMemberItem item={teamMember} key={teamMember.id} linkTarget={linkTarget} />
        ))}
      </ul>
    </Section>
  )
}
